import { Component, OnInit } from '@angular/core';
import { TopicService } from '../../service/topic.service';
import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Globals } from '../../globals';
import { contentService } from '../../service/content.service';
import { commonService } from '../../service/common.service';


@Component({
  selector: 'app-freedownload',
  templateUrl: './freedownload.component.html',
  styleUrls: ['./freedownload.component.css'],
  providers:[contentService,commonService]
})
export class FreedownloadComponent implements OnInit  {
  start:any=0;
  end:any=10;
  pageSize = 10;
  serach:any;
  contentlist:any;
  totalrow:0;
  notfound:any;
  msg="";
  isError:boolean;
  currentPage = 0;
  isSuccess=false;
  pageEvent:any;
 

  constructor(private _content:contentService,public router: Router, private global: Globals,private commonService:commonService) { }

  ngOnInit() {
    this.getfreedownload();
  }
  // paging handle
  handlePage(e: any){
    this.currentPage = e.pageIndex;
    this.pageSize = e.pageSize;
    this.end = this.pageSize;
    this.start = this.currentPage * this.pageSize; 
    this.getfreedownload()    
  }
  

  getfreedownload(){
    let obj={}
    obj['limit']=this.end;
    obj['offset']=this.start;
    obj['search']=this.serach;
    obj['type'] = 'admin';

    this._content.getdownloadContent(obj).subscribe((data : any)=>{
            if(data.error==0){ 
              this.contentlist = data.results.rows;
              this.totalrow = data.results.count;
              if(this.totalrow==0){
                this.notfound=true;
              }else{
                this.notfound=false;
              }
            }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
               this.msg = data.message;
               this.isError = true;
              }
            }
     },
       (error : HttpErrorResponse)=>{
         this.isError = true;
         this.msg="internal server error!";
       });
  
}
filterform(searchtxt){
  var txt = searchtxt.value.search.trim();
  
  //this.router.navigateByUrl('/admin/discussion/topic?search='+txt);
  
  this.serach=txt;
  this.start=0;
  this.getfreedownload();  
}

    getTopicImage(imagename){
      return this.global.topicImageUrl+imagename;
      
    }

    customEnode(data){
      return encodeURI(btoa(data));
    }

    deltopic(id,index){
     if(confirm('do you want to delete?')){
      //let obj={};
     var  objid =parseInt(id);
      this._content.deldownloadContent({'docId':objid}).subscribe((data:any)=>{
        if(data.error==0){
          this.contentlist.splice(index,1);
          this.totalrow -=1;
        

        }

      },(error:HttpErrorResponse)=>{
        this.isError = true;
        this.msg="internal server error!";

      })

     
     }else{

      console.log('not deleted');
     }
    }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/freedownload/freedownload.component.ts